import React from 'react';
import { Link } from 'react-style-guide';
import PropTypes from 'prop-types';
import {
  Thumbnail2d,
  ThumbnailTypes,
  ThumbnailGameThumbnailSize,
  ThumbnailGameIconSize,
  ThumbnailFormat
} from 'roblox-thumbnails';
import gameTileUtils from '../utils/gameTileUtils';
import GameName from './GameName';
import CardInfo from './CardInfo';
import NativeAd from './NativeAd';
import HoverGameTileContents from './HoverGameTileContents';

const HoverGameTile = React.forwardRef((props, ref) => {
  const { game, isVisible, pageType, index, sortName, pageContext, sortPosition, dateTime } = props;
  const { placeId, universeId, gameDescription } = game;
  const gameReferralUrl = gameTileUtils.getGameReferralUrl(
    game,
    pageType,
    index,
    sortName,
    pageContext,
    sortPosition,
    dateTime,
    placeId,
    true
  );
  game.referralUrl = gameReferralUrl;

  return (
    <div className='featured-game-container game-card-container' ref={ref}>
      <Link url={gameReferralUrl} className='game-card-link'>
        {isVisible && (
          <div className='thumb-container'>
            <Thumbnail2d
              type={ThumbnailTypes.universeThumbnail}
              size={ThumbnailGameThumbnailSize.width576}
              targetId={universeId}
              imgClassName='thumb'
              format={ThumbnailFormat.jpeg}
              altName={game.name}
            />
            <div className='thumb-mask' />
          </div>
        )}

        <div className='featured-game-icon-container'>
          <Thumbnail2d
            type={ThumbnailTypes.gameIcon}
            size={ThumbnailGameIconSize.size512}
            targetId={universeId}
            containerClass='brief-game-icon'
            format={ThumbnailFormat.jpeg}
            altName={game.name}
          />
        </div>

        <div className='info-container'>
          <GameName game={game} />
          {game.isShowSponsoredLabel && <NativeAd {...props} />}
          {!game.isShowSponsoredLabel && <CardInfo game={game} />}
        </div>
      </Link>

      <HoverGameTileContents placeId={placeId} gameDescription={gameDescription} />
    </div>
  );
});

HoverGameTile.defaultProps = {
  isVisible: false,
  sortName: null,
  sortPosition: -1,
  pageContext: { pageId: null },
  dateTime: null
};

HoverGameTile.propTypes = {
  game: PropTypes.shape({
    universeId: PropTypes.number,
    placeId: PropTypes.number,
    name: PropTypes.string,
    gameDescription: PropTypes.string,
    playerCount: PropTypes.number,
    isShowSponsoredLabel: PropTypes.bool,
    nativeAdData: PropTypes.string,
    referralUrl: PropTypes.string
  }).isRequired,
  isVisible: PropTypes.bool,
  pageType: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  sortName: PropTypes.string,
  pageContext: PropTypes.shape({ pageId: PropTypes.string }),
  sortPosition: PropTypes.number,
  dateTime: PropTypes.string
};
HoverGameTile.displayName = 'HoverGameTile';
export default HoverGameTile;
